import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { fixDecimals, text_truncate } from '../../../../helpers';
import Table, { RowsType } from '../../../Shared/CustomTable';
import { useRouter } from '../../../../helpers/customHooks';
import { Cell1Type, Cell2Type, Cell3Type, Cell4Type, TeamPlayersTablePropsType } from './types';
import { FILTER_KEYS, MESSAGES } from 'config/constants';
import { useFiltersState } from 'store/hooks';
import Loader from 'components/Shared/Loader';

const TeamPlayersTable = ({ dataPlayers, headers }: TeamPlayersTablePropsType) => {
  
  const { search, pathname, specificScope } = useRouter();
  const {
    [FILTER_KEYS.POSITIONS]: filterPositionsData,
  } = useFiltersState(specificScope, FILTER_KEYS.POSITIONS);
  let positionFilter: any;
  if(filterPositionsData && filterPositionsData.length > 0){
    positionFilter = filterPositionsData.map(obj => obj.value);
  }
  const rows: RowsType<Cell1Type, Cell2Type, Cell3Type, Cell4Type, string, number, JSX.Element> = [];
  
  if (dataPlayers) {
    for (const key in dataPlayers) {
      const player = dataPlayers[key];
      const shouldPush = positionFilter?(positionFilter.length === 0 || positionFilter.includes(player.meta.position)): true;
      if(shouldPush){
      rows.push({
          columns: [
            {
              content: {
                name: player.meta.name,
                playerId: player.meta.playerId
              },
              // class: 'player-img',
              print: (content: Cell1Type) => (
                <Link
                  to={{
                    pathname: `/player/${content.playerId}`,
                    search: search,
                    state: { toReturn: pathname, toReturnSearch: search }
                  }}
                >
                  <label className="l-c" style={{ color: '#333d47', cursor: 'inherit' }}>
                    <b>{text_truncate(content.name, 17)}</b>
                  </label>
                </Link>
              ),
              order: (contentA: Cell1Type, contentB: Cell1Type) => {
                if (contentA.name.split(' ').length < 2) {
                  return contentA.name.localeCompare(contentB.name);
                }
                const lastNameA = contentA.name.split(' ')[1];
                const lastNameB = contentB.name.split(' ')[1];
                return lastNameA.localeCompare(lastNameB);
              },
              style: {
                // backgroundImage: `url(https://static.nfl.com/static/content/public/static/img/fantasy/transparent/200x200/${player.eid}.png)`,
                paddingLeft: '20px'
              }
            },
            {
              content: player.meta.jersey,
              print: (content: string) => <label className="l-c">#{content}</label>,
              order: (contentA: string, contentB: string) => {
                const jerseyA =  contentA.replace(/\D/g, '');
                const jerseyB =  contentB.replace(/\D/g, '');
                const jerseyLetterA = contentA.replace(jerseyA, '');
                const jerseyLetterB = contentB.replace(jerseyB, '');
                if (+jerseyA !== +jerseyB) {
                  return +jerseyB- +jerseyA;
                   
                }
                return jerseyLetterB.localeCompare(jerseyLetterA);
                
              }
            },
            {
              content: player.meta.position,
              print: (content: string) => <label className="l-c">{content}</label>,
              order: (contentA: string, contentB: string) => contentA.localeCompare(contentB)
            },
            {
              class: 'll-pp',
              content: {
                printAveSpeedMPH: isNaN(player.metrics.aveMaxSpeedMPH) ? '-' : fixDecimals(player.metrics.aveMaxSpeedMPH, 1),
                aveSpeedMPH: isNaN(player.metrics.aveMaxSpeedMPH) ? -1000000 : player.metrics.aveMaxSpeedMPH
              },
              print: (content: Cell2Type) => <label className="l-c">{content.printAveSpeedMPH}</label>,
              order: (contentA: Cell2Type, contentB: Cell2Type) => contentA.aveSpeedMPH - contentB.aveSpeedMPH
            },
            {
              class: 'll-pp',
              content: {
                printAveMaxSustainedSpeed: isNaN(player.metrics.aveMaxSustainedSpeedMPH) ? '-' : fixDecimals(player.metrics.aveMaxSustainedSpeedMPH, 1),
                aveMaxSustainedSpeed: isNaN(player.metrics.aveMaxSustainedSpeedMPH) ? -1000000 : player.metrics.aveMaxSustainedSpeedMPH
              },
              print: (content: Cell3Type) => <label className="l-c">{content.printAveMaxSustainedSpeed}</label>,
              order: (contentA: Cell3Type, contentB: Cell3Type) => contentA.aveMaxSustainedSpeed - contentB.aveMaxSustainedSpeed
            },
            {
              class: 'll-pp',
              content: {
                printAveDistYards: isNaN(player.metrics.aveDistYards) ? '-' : fixDecimals(player.metrics.aveDistYards, 0),
                aveDistYards: isNaN(player.metrics.aveDistYards) ? -1000000 : player.metrics.aveDistYards
              },
              print: (content: Cell4Type) => <label className="l-c">{content.printAveDistYards}</label>,
              order: (contentA: Cell4Type, contentB: Cell4Type) => contentA.aveDistYards - contentB.aveDistYards
            },
            // {
            //   class: 'll-pp',
            //   content: {
            //     printAveHardEffortDist: isNaN(player.metrics.aveHardEffortDist) ? '-' : fixDecimals(player.metrics.aveHardEffortDist, 0),
            //     aveHardEffortDist: isNaN(player.metrics.aveHardEffortDist) ? -1000000 : fixDecimals(player.metrics.aveHardEffortDist, 0)
            //   },
            //   print: (content) => <label className="l-c">{content.printAveHardEffortDist}</label>,
            //   order: (contentA, contentB) => contentA.aveHardEffortDist - contentB.aveHardEffortDist
            // },
            
            {
              content: player.metrics.accelsAve,
              print: (content: number) => (
                <label className="l-c">
                  {isNaN(content) ? '-' : fixDecimals(content, 0)}
                </label>
              ),
              class: 'll-pp',
              order: (contentA: number, contentB: number) => contentA - contentB
            },
            {
              content: player.metrics.deccelsAve,
              print: (content: number) => (
                <label className="l-c">
                  {isNaN(content) ? '-' : fixDecimals(content, 0)}
                </label>
              ),
              class: 'll-pp',
              order: (contentA: number, contentB: number) => contentA - contentB
            },
            {
              content: (
                <Link
                  to={{
                    pathname: `/player/${player.meta.playerId}`,
                    search: search,
                    state: { toReturn: pathname, toReturnSearch: search }
                  }}
                >
                  <Button className="btn-blue">View Profile</Button>
                </Link>
              ),
              class: 'oo-u'
            }
          ],
          id: key
        }
      );
    }
    }
  }
  
  return (
    <Loader forceMessage={rows.length === 0? MESSAGES.EMPTY:''}>
    <Table
      headers={headers}
      rows={rows}
      default={{ orderColumn: -1 }}
    />
    </Loader>
  );
};

export default TeamPlayersTable;